import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customIsoDate',
    standalone: false
})
export class CustomIsoDatePipe implements PipeTransform {
    transform(value: any, isFullDay: boolean, isOnlyDate: boolean = false): any {
        if (!value) return;
        const today = value;
        const dayOfMonth = today.substring(8, 10);
        const month = today.split('-')[1];
        const year = today.split('-')[0];
        const hour = today.split(':')[0];
        const minutes = today.split(':')[1];
        if (isOnlyDate) {
            return dayOfMonth + '.' + month + '.' + year;
        }
        if (isFullDay) {
            return dayOfMonth + '.' + month + '.' + year + ' | 23:59';
        } else {
            return dayOfMonth + '.' + month + '.' + year + ' | ' + hour.substring(11, 13) + ':' + minutes;
        }
    }
}
